import config from './config.js'
import axios from '../../node_modules/axios/dist/axios.min.js'

export default {

  // selection parameter
  viewparams: { start:0,count:20},

  // list selected reports
  list: function(cb_success) {
    var u = config.baseUrl + 'rest/reports/?start=' + this.viewparams.start + '&count=' + this.viewparams.count;
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  },

  // load a single report
  load: function(id,cb_success) {
    var u = config.baseUrl + 'rest/reports/' + encodeURIComponent(id);
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  },

  delete: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/reports/' + encodeURIComponent(id),'Bericht löschen',cb_success);
  },

  save: function(ctrl,report,cb_success) {
      console.log('save report: ',report);

      var fd = new FormData();
      fd.append("id",report.id || 0);
      fd.append('name',report.name);
      fd.append('cron',report.cron);
      fd.append('format',report.format);
      fd.append('datasource',JSON.stringify(report.datasource));
      fd.append('output',report.output);
      fd.append('params',JSON.stringify(report.params || {}));
      fd.append('email',report.email);
      fd.append('type',report.type + '');
      fd.append('tempname',report.template);

      config.post(ctrl,config.baseUrl + 'rest/reports/upload','Bericht speichern',fd,cb_success);
  },

  // liste der vorhanden templates
  templates: function(cb_success) {
    var u = config.baseUrl + 'rest/reports/templates';
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  },

  updateTemplate(key,file,ow) {
    var url = config.baseUrl + 'rest/reports/templates/' + encodeURIComponent(key);
    if (ow) url += '?overwrite=1';
    return axios.post(url,file);
  },

  // bericht ausführen
  execute: function(ctrl,id,dash,cb_success) {
    var url = config.baseUrl + 'rest/reports/exec/' + encodeURIComponent(id);
    if (dash) {
      url += '?dash=' + encodeURIComponent(dash);
    }
    config.get(ctrl,url,'Bericht ausführen',cb_success);
  },

  // bericht erstellen (non job)
  create: function(ctrl,report,params,dash,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/reports/create?dash=' + encodeURIComponent(dash),
      'Bericht ausführen',
      JSON.stringify({report: report,params: params}),cb_success);
  },

  injectparams: function(ctrl,cfg,params,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/reports/injectparams','Parameter aktualisieren',JSON.stringify({config: cfg, params: params }),cb_success);
  }
}
